import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-current-day-cusp-display',
  templateUrl: './current-day-cusp-display.component.html',
  styleUrls: ['./current-day-cusp-display.component.css']
})
export class CurrentDayCuspDisplayComponent implements OnInit {

  @Input() preDayIcon!: string;
  @Input() postDayIcon!: string;
  @Input() currentIndexId!: number;
  @Input() preSignName!: string;
  @Input() postSignName!: string;
  @Input() currentMontName!: string;
  @Input() postColor!: string;
  @Input() preColor!: string;


  @Input() preElement!: string;
  @Input() preQuality!: string;
  @Input() preGlyph!: string;
  @Input() preHouse!: string;
  @Input() prePlanet!: string;

  @Input() postElement!: string;
  @Input() postQuality!: string;
  @Input() postGlyph!: string;
  @Input() postHouse!: string;
  @Input() postPlanet!: string;

  @Output() seeDifferentMonth: EventEmitter<any> = new EventEmitter();
  @Output() setDisplay: EventEmitter<any> = new EventEmitter();



  // @Input() preSignProfile!: object;
  // @Input() postSignProfile!: object;

  element: any ="";

  monthIs : any = {};
  weekdayIs: any = {};
  dayIs: any = {};
  hourIs: any = {};
  minIs: any = {};
  now: any = new Date();

  constructor() {
    // this.preSignProfile = {};
   }

  ngOnInit(): void {
    // console.log('presign obj', this.preSignProfile)
    var monthArrayId = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    var da = new Date();

    var currentMonthIndexId = monthArrayId[da.getMonth()];

  

  }
  ngOnChanges(changes: SimpleChanges){
    this.setData();
    this.formatDate();
  }

  setData(){

      // console.log('element check', this.preSignProfile.hasOwnProperty('family'));
      // if (this.preSignProfile.hasOwnProperty('family')){


      //   // this.element = this.preSignProfile.hasOwnProperty('family') ? this.preSignProfile : '';
      //   // console.log('its true', this.preSignProfile.hasOwnProperty('family'), 'element is', this.element );
      //   // this.preSignProfile = this.preSignProfile;
      //   // this.element = this.preSignProfile.family;
      // } else {
      //   null
      // }


    // this.element = this.preSignProfile.hasOwnProperty('family') ? this.preSignProfile.family : null;

  };

  formatDate() {
    var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    var weekday  = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    var d = new Date();
    this.monthIs = month[d.getMonth()];
    this.weekdayIs = weekday[d.getDay()];
    this.dayIs = d.getDate();
    this.hourIs = d.getHours();
    this.minIs = d.getMinutes()
    

  };

  prevMonth(){
    this.seeDifferentMonth.emit('prev');
    this.setDisplay.emit('show2');
  };
  nextMonth(){
    this.seeDifferentMonth.emit('next');
    this.setDisplay.emit('show2');
  };
  prevSign(){
    this.setDisplay.emit('show1prev');
  };
  postSign(){
    this.setDisplay.emit('show1post');
  }


}
